import { Link } from "react-router-dom";
import constants from "../constants/constants";


export default function Tools() {
  return (
    <section className="py-16">
      <h1 className="text-4xl text-white py-8 font-mont text-center">
        USEFUL TOOLS
      </h1>
      <div className="grid md:grid-cols-3 gap-10 max-w-[90vw] mx-auto px-7 mb-10">
        {constants.TOOLS.map((tool, idx) => (
          <Link key={tool.href} to={tool.href} className="group block">
            <div className="relative h-96 flex items-end justify-center">
              {/* Bottom image card (wider, offset) */}
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[92%] h-[82%] rounded-3xl shadow-2xl z-0 scale-105 group-hover:scale-110 transition-transform duration-300 bg-black/10 overflow-hidden">
                <img
                  className="w-full h-full object-cover"
                  src={tool.image}
                  alt={tool.alt}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-black/10 to-transparent" />
              </div>
              {/* Top glass card (smaller, centered) */}
              <div className="relative w-[60%] h-[70%] rounded-2xl bg-white/30 backdrop-blur-lg border border-white/30 shadow-xl z-10 flex flex-col justify-center items-center px-6 py-8 transition-all duration-300 group-hover:shadow-2xl group-hover:-translate-y-2 group-hover:scale-105">
                <h3 className="text-2xl text-cyan-700 font-mont mb-2 drop-shadow-lg text-center font-bold">
                  {tool.title}
                </h3>
                <span className="font-mont text-black/80 drop-shadow text-center">
                  {tool.subtitle}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
